module.exports = __webpack_public_path__ + "static/media/blue-white-measure-tape.b048c06e.png";